import { useTranslate } from 'hooks/useTranslate';
import downloadDocument from 'utils/downloadDocument';

import Button, { ButtonVariants } from 'modules/_shared/components/Buttons';

import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';

const CommunicationAttachmentsSection = () => {
  const { t } = useTranslate();
  const { data } = useCommunicationDetailsPage();
  const { communication } = data;

  const hasAttachments = (communication?.attachments ?? []).length > 0;
  const attachmentCount = communication?.attachments?.length ?? 0;

  return (
    <div className="cm-attachments">
      <div className="cm-section-header">
        <h6 className="cm-section-header__title">
          <em className="icon ni ni-clip-h" />
          {attachmentCount} {t('FilesAttached')}
        </h6>
        <Button
          className={`cm-section-header__link ${
            !hasAttachments ? 'cm-section-header__link--disabled' : ''
          }`}
          variant={ButtonVariants.LINK}
          icon="download"
          text={t('DownloadAll')}
          disabled={!hasAttachments}
          onClick={() =>
            downloadDocument({
              multiple: true,
              documents: data.attachedDocuments,
            })
          }
        />
      </div>

      {data.attachedDocuments?.length > 0 && (
        <ul className="cm-attachments__list">
          {data.attachedDocuments.map((attachment: any) => (
            <li key={attachment._id} className="cm-attachments__item">
              <em className="icon ni ni-file-doc cm-attachments__item-icon" />
              <span className="cm-attachments__item-name">
                {attachment?.name}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CommunicationAttachmentsSection;
